module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10019.211ee360.jpg";